import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

// core components
import GridContainer from 'components/Grid/GridContainer';
import withStyles from '@material-ui/core/styles/withStyles';
import GridItem from 'components/Grid/GridItem';
import { Button, Card, Hidden, MenuItem, Select, TextField } from '@material-ui/core';

// styling
import Style from 'assets/jss/material-dashboard-pro-react/views/adStyle';


export function AdName(props) {
    const { classes, history, adName, setAdName, errors } = props;
    return (
        <div>
            <Hidden smDown implementation="css">
                <Card className={classes.card}>
                    <GridContainer>
                        <GridItem xs={12} >
                            <div style={{ display: "flex" }}>
                                <p style={{ fontWeight: 600, marginRight: "10px", marginTop: "5px", whiteSpace: "noWrap", }}>Title</p>
                                <TextField
                                    style={{ marginLeft: "20px" }}
                                    className={classes.textField}
                                    value={adName}
                                    onChange={(e) => setAdName(e.target.value)}
                                    // variant="outlined"
                                    InputProps={{
                                        disableUnderline: true,
                                        classes: {
                                            input: classes.input
                                        },
                                    }}
                                />
                            </div>
                            {errors.adName ?
                                <p className={classes.errText}>Input cannot be empty</p>
                                : null
                            }
                        </GridItem>

                    </GridContainer>
                </Card>
            </Hidden>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        // nothing yet
    };
}
function mapDispatchToProps(actions) {
    return (dispatch) => ({

    });
}
export default withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(AdName));